const tr = {
  epayTransactions: {
    attributes: {
      id: 'ID',
      product: 'Produto',
      product_id: 'Produto',
      tx_id: 'TXID',
      tx_ref: 'TXREF',
      status: 'Status',
      type: 'Tipo',
      result: 'Código de resposta',
      result_text: 'Resposta da transação',
      quantity_pending: 'Quantidade de consultas pendentes',
      terminal_id: 'Terminal ID',
      username: 'Nome do usuário',
      mode: 'MODE',
      max_timeout: 'Tempo máximo de espera',
      local_datetime: 'Data local',
      chars_per_line: 'Máximo de caracteres por linha',
      ean: 'EAN',
      amount: 'Quantidade',
      currency: 'Moeda ISO',
      language: 'Linguagem ISO',
      valid_to: 'Válido até',
      server_datetime: 'Data do server',
      receipt_quantity_lines: 'Quantidade de linhas do recibo',
      receipt_body_lines: 'Corpo do recibo',
      serial: 'Serial',
      pin: 'PIN',
      pin_id: 'PIN',
      epay_user: 'Usuário da Epay',
      epay_user_id: 'Usuário da Epay',
      limit: 'Limite',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras: {
      show: 'Visualizando Transação da Epay',
      search: 'Digite o ID, TXID ou TXREF',
      dateType: 'Tipo de data',
      date_init: 'Data inicial',
      date_end: 'Data final',
    },
    defSingular: 'Transação da Epay',
    defPlural: 'Transações da Epay',
  },
};

export default tr;
